export default "__VITE_ASSET__BT$ptvlR__"